import * as yup from 'yup';

export const RewardChallengeValidationSchema = {
  name: yup
    .string()
    .min(4, 'Name is too short!')
    .max(50, 'Name is too long!')
    .required('Name is required!'),
  rewardIdentity: yup.string().required('Reward Identity is required!'),
  points: yup
    .number()
    .typeError('Points must be a number')
    .min(0, 'Points must be positive')
    .required('Points are required!'),
  maximumDays: yup
    .number()
    .typeError('Maximum days must be a number')
    .min(0, 'Maximum days must be positive')
    .required('Maximum days are required!')
};
export const RewardChallengeEditValidationSchema = {
  name: yup
    .string()
    .min(4, 'Name is too short!')
    .max(50, 'Name is too long!')
    .required('Name is required!'),
  rewardIdentity: yup.string().required('Reward Identity is required!'),
  points: yup
    .number()
    .typeError('Points must be a number')
    .min(0, 'Points must be positive')
    .required('Points are required!'),
  maximumDays: yup
    .number()
    .typeError('Maximum days must be a number')
    .min(0, 'Maximum days must be positive')
    .required('Maximum days are required!')
};
